var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45.3442,
    r: 44.5,
    stroke: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.9945 31.3442C46.9945 30.5158 46.3229 29.8442 45.4945 29.8442C44.6661 29.8442 43.9945 30.5158 43.9945 31.3442L46.9945 31.3442ZM44.4338 61.4049C45.0196 61.9907 45.9694 61.9907 46.5552 61.4049L56.1011 51.859C56.6869 51.2732 56.6869 50.3234 56.1011 49.7376C55.5153 49.1519 54.5656 49.1519 53.9798 49.7376L45.4945 58.2229L37.0092 49.7376C36.4234 49.1518 35.4737 49.1518 34.8879 49.7376C34.3021 50.3234 34.3021 51.2732 34.8879 51.859L44.4338 61.4049ZM43.9945 31.3442L43.9945 60.3442L46.9945 60.3442L46.9945 31.3442L43.9945 31.3442Z",
    fill: "#F7F8FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll_down.a6b8246745eededcb59be44b929403e0.svg";
export { ForwardRef as ReactComponent };